import { Tooltip } from "antd";
import React from "react";

export default function InlineTooltip({ children, title }) {
  return (
    <Tooltip title={title}>
      <span style={{ borderBottom: "solid 1px #ccc" }}>{children}</span>
    </Tooltip>
  );
}
